module.exports = __webpack_public_path__ + "static/media/logo_negativo.c9849a08.png";